/**
 * Logger utility for console statements
 * Prevents console output in production while allowing development debugging
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * Logs messages only in development mode
   * @param args - Arguments to log
   */
  log: (...args: any[]): void => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Logs errors - always logs in both development and production
   * Errors should be visible for debugging production issues
   * @param args - Arguments to log
   */
  error: (...args: any[]): void => {
    console.error(...args);
    // Optionally send to error tracking service here
  },

  /**
   * Logs debug messages only in development mode
   * @param args - Arguments to log
   */
  debug: (...args: any[]): void => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  /**
   * Logs warnings only in development mode
   * @param args - Arguments to log
   */
  warn: (...args: any[]): void => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  /**
   * Logs info messages only in development mode
   * @param args - Arguments to log
   */
  info: (...args: any[]): void => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
};

export default logger;
